<script lang="ts" setup>
  import { useEventEntryProps } from "frontend/uses/use-event-entry";

  defineProps({ ...useEventEntryProps() });
</script>

<template>
  <div><!-- empty --></div>
</template>
